import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/imgs/logo-title.svg';
import _imports_1 from '../assets/imgs/help-icon.svg';
import _imports_2 from '../assets/imgs/link-with.svg';
const _withScopeId = n => (_pushScopeId("data-v-1e4e3bb4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login-title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "align-items": "center"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "vector",
  src: _imports_0
}), /*#__PURE__*/_createElementVNode("span", {
  class: "vector-text2"
}, " 软件开放平台 ")], -1));
const _hoisted_3 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {
    "height": "25px",
    "width": "25px"
  }
}, null, -1));
const _hoisted_5 = {
  class: "title-right-text",
  style: {
    "padding-right": "45px",
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {
    "height": "25px",
    "width": "25px"
  }
}, null, -1));
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_9 = ["title"];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "width": "50px"
  }
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_t_icon = _resolveComponent("t-icon");
  const _component_t_dropdown = _resolveComponent("t-dropdown");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_t_dropdown, {
    options: _ctx.helpOptions,
    minColumnWidth: 120,
    onClick: _ctx.handleHelpClick
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createTextVNode(" 帮助文档 "), _createVNode(_component_t_icon, {
      name: "chevron-down",
      style: {
        "margin-left": "4px",
        "height": "14px",
        "width": "14px"
      }
    })])]),
    _: 1
  }, 8, ["options", "onClick"]), _hoisted_6, _createElementVNode("span", {
    class: "title-right-text",
    style: {
      "padding-right": "70px"
    },
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.goContactus && _ctx.goContactus(...args))
  }, " 联系我们 "), _ctx.data.figureurl ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "portrait",
    src: _ctx.data.figureurl
  }, null, 8, _hoisted_7)) : _createCommentVNode("", true), _ctx.data.nickname ? (_openBlock(), _createBlock(_component_t_dropdown, {
    key: 1,
    options: _ctx.dropdowns,
    onClick: _ctx.clickHandler
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
      class: "qq-name",
      title: _ctx.data.nickname
    }, _toDisplayString(_ctx.data.nickname), 9, _hoisted_9), _createElementVNode("div", null, [_createVNode(_component_t_icon, {
      name: "chevron-down",
      style: {
        "height": "15px",
        "width": "15px"
      }
    })])])]),
    _: 1
  }, 8, ["options", "onClick"])) : _createCommentVNode("", true), !_ctx.data.nickname ? (_openBlock(), _createElementBlock("span", {
    key: 2,
    style: {
      "cursor": "pointer"
    },
    class: "qq-name",
    onClick: _cache[1] || (_cache[1] = () => {
      _ctx.$router.push({
        path: '/login'
      });
    })
  }, " 请登录 ")) : _createCommentVNode("", true), _hoisted_10])]);
}